import { ParcelSizes, ParcelSizesFormValues } from "../financial.types";

export const getInitialParcelSizesFormValues = (
  parcelSizes: ParcelSizes
): ParcelSizesFormValues => {
  return {
    s: {
      minVolume: String(parcelSizes.s.minVolume),
      maxVolume: String(parcelSizes.s.maxVolume),
      minWeight: String(parcelSizes.s.minWeight),
      maxWeight: String(parcelSizes.s.maxWeight)
    },
    m: {
      minVolume: String(parcelSizes.m.minVolume),
      maxVolume: String(parcelSizes.m.maxVolume),
      minWeight: String(parcelSizes.m.minWeight),
      maxWeight: String(parcelSizes.m.maxWeight)
    },
    l: {
      minVolume: String(parcelSizes.l.minVolume),
      maxVolume: String(parcelSizes.l.maxVolume),
      minWeight: String(parcelSizes.l.minWeight),
      maxWeight: String(parcelSizes.l.maxWeight)
    }
  };
};
